var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.625V12.875M6.44922 7.02051C6.44922 5.63379 7.69434 4.53516 9.12988 4.78418C10.2236 4.96973 11.0342 5.98535 11 7.09375C10.9707 8.04102 10.3701 8.70508 9.6084 9.04199C8.89551 9.35938 8.5 9.59863 8.5 10.375M16 8.5C16 12.6406 12.6406 16 8.5 16C4.35938 16 1 12.6406 1 8.5C1 4.35938 4.35938 1 8.5 1C12.6406 1 16 4.35938 16 8.5Z",
    stroke: "#A5B3BD",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.b548a87f720c49d782c8c863fde0d46c.svg";
export { ForwardRef as ReactComponent };